<template>
  <div id="app" v-if="this.$router?.currentRoute?.value?.fullPath?.includes('forecast')">
    <HeaderForecast v-if="!mainStore.access_token_forecast" class="w-full max-w-[560px] pt-[20px] px-[20px]" />
    <main class="w-full max-w-[560px] pt-[20px] px-[20px]" :class="mainStore.mode">
      <HeaderForecast v-if="!!mainStore.access_token_forecast" />
      <router-view v-if="!!mainStore.access_token_forecast" />
      <LoginViewForecast v-else />
    </main>
    <FooterForecast class="w-full max-w-[560px]" />
    <notifications />
  </div>
  <div id="app" v-else>
    <Header v-if="!mainStore.access_token" class="w-full max-w-[560px] pt-[20px] px-[20px]" />
    <main class="w-full max-w-[560px] pt-[20px] px-[20px]" :class="mainStore.mode">
      <Header v-if="!!mainStore.access_token" />
      <router-view v-if="!!mainStore.access_token" />
      <LoginView v-else />
    </main>
    <Footer class="w-full max-w-[560px]" />
    <notifications />
  </div>
</template>

<script>
import Header from './components/Header.vue';
import HeaderForecast from './components/forecast/Header.vue';
import LoginView from './components/LoginView.vue';
import LoginViewForecast from './components/forecast/LoginView.vue';
import Footer from './components/Footer.vue';
import FooterForecast from './components/forecast/Footer.vue';
import { mainStore } from '../store/main';
import axios from 'axios';

export default {
  name: 'App',
  components: {
    Header, LoginView, Footer,
    HeaderForecast, LoginViewForecast, FooterForecast
  },
  data() {
    return {
      mainStore
    }
  },
  async created() {
    if (window?.location?.href?.includes("forecast")) {
      this.mainStore.isForecast = true;
      this.mainStore.access_token_forecast = this.$cookies.get("token_forecast");
      this.mainStore.refresh_token_forecast = this.$cookies.get("refreshToken_forecast");
      await this.refreshTokenForecast(false);

      setInterval(async () => {
        if (this.mainStore.access_token_forecast) {
          await this.refreshTokenForecast(true);
        }
      }, 270000) //270000
    } else {
      this.mainStore.isForecast = false;
      this.mainStore.access_token = this.$cookies.get("token");
      this.mainStore.refresh_token = this.$cookies.get("refreshToken");
      await this.refreshToken(false);

      setInterval(async () => {
        if (this.mainStore.access_token) {
          await this.refreshToken(true);
        }
      }, 270000) //270000
    }
  },

  methods: {
    async refreshToken(isErrorNotifyOn) {
      const loader = this.$loading.show();

      this.mainStore.isForecast = false;

      try {
        const response = await axios.post(`${process.env.VUE_APP_HOST}/auth/realms/${process.env.VUE_APP_REALM}/protocol/openid-connect/token`, {
          client_id: process.env.VUE_APP_CLIENT_ID,
          grant_type: "refresh_token",
          refresh_token: this.mainStore?.refresh_token
        }, { headers: { "content-type": "application/x-www-form-urlencoded" } })

        this.$cookies.set("token", response.data?.access_token);
        this.$cookies.set("refreshToken", response.data?.refresh_token);
        this.mainStore.access_token = response.data?.access_token;
        this.mainStore.refresh_token = response.data?.refresh_token;
      } catch (error) {
        console.log("e", error);
        this.$cookies.remove("token");
        this.$cookies.remove("refreshToken");
        this.mainStore.access_token = null;
        this.mainStore.refresh_token = null;

        if (isErrorNotifyOn) {
          this.$notify({
            title: "Errore nel caricamento dell'accesso",
            //text: error?.response?.data?.error_description ? error.response.data.error_description : error?.response?.data?.error,
            type: "error",
          });
        }
      }

      loader.hide();
    },
    async refreshTokenForecast(isErrorNotifyOn) {
      const loader = this.$loading.show();

      this.mainStore.isForecast = true;

      try {
        const response = await axios.post(`${process.env.VUE_APP_HOST}/auth/realms/${process.env.VUE_APP_REALM_FORECAST}/protocol/openid-connect/token`, {
          client_id: process.env.VUE_APP_CLIENT_ID_FORECAST,
          grant_type: "refresh_token",
          refresh_token: this.mainStore?.refresh_token_forecast
        }, { headers: { "content-type": "application/x-www-form-urlencoded" } })

        this.$cookies.set("token_forecast", response.data?.access_token);
        this.$cookies.set("refreshToken_forecast", response.data?.refresh_token);
        this.mainStore.access_token_forecast = response.data?.access_token;
        this.mainStore.refresh_token_forecast = response.data?.refresh_token;
      } catch (error) {
        console.log("e", error);
        this.$cookies.remove("token_forecast");
        this.$cookies.remove("refreshToken_forecast");
        this.mainStore.access_token_forecast = null;
        this.mainStore.refresh_token_forecast = null;

        if (isErrorNotifyOn) {
          this.$notify({
            title: "Errore nel caricamento dell'accesso",
            //text: error?.response?.data?.error_description ? error.response.data.error_description : error?.response?.data?.error,
            type: "error",
          });
        }
      }

      loader.hide();
    },
  }
}
</script>

<style>
@import "./main.css";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  background-color: #f8f9fa;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  min-height: 100vh;
  width: 100%;
}
</style>
